import { TTheme } from '@/core/theme'
import { SEVERITY_CONFIG } from '@/ui/utils/utils'
import { styled } from '@mui/system'
import Typography from '../typography'

export const SeverityText = styled(Typography)<{ theme?: TTheme }>`
    display: flex;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.greys[0]};
`

export const TextAndIconWrapper = styled('div')`
    display: flex;
    gap: 9px;
    align-items: center;
`

export const SeverityIndicatorWrapper = styled('div')<{
    severity: TIssueSeverity
    theme?: TTheme
}>`
    display: flex;
    gap: 10px;
    padding: 10px 15px;
    width: fit-content;
    border-radius: 12px;
    background: ${({ theme, severity }) =>
        SEVERITY_CONFIG[severity].color(theme)};
`
